import { render, staticRenderFns } from "./LegalNotice.vue?vue&type=template&id=22764627&scoped=true"
import script from "./LegalNotice.vue?vue&type=script&lang=js"
export * from "./LegalNotice.vue?vue&type=script&lang=js"
import style0 from "./LegalNotice.vue?vue&type=style&index=0&id=22764627&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22764627",
  null
  
)

export default component.exports